import { z } from 'zod';

import { USER_ROLES } from '../../constants/user.constants';
import { requiredString } from '../base.schema';
import { zObjectId } from './../mongo.schema';

export const userSchemaRef = 'User';

export const userSchema = z
	.object({
		id: zObjectId.meta({
			description: 'Unique identifier for the user.',
			example: '123e4567-e89b-12d3-a456-426614174000',
		}),
		name: requiredString('schemaAttributes.name').meta({
			description: 'Full name of the user.',
			example: 'John Doe',
		}),
		email: requiredString('schemaAttributes.email').meta({
			description: 'Email address of the user.',
			example: 'example@example.com',
		}),
		role: z.enum(USER_ROLES).meta({
			description: 'Role of the user in the system.',
			example: USER_ROLES.USER,
		}),
		createdAt: z
			.union([z.string().datetime('Invalid date format'), z.date()])
			.meta({
				description: 'Date and time when the user was created.',
				example: '2023-10-01T12:00:00Z',
			}),
		updatedAt: z
			.union([z.string().datetime('Invalid date format'), z.date()])
			.meta({
				description: 'Date and time when the user was last updated.',
				example: '2023-10-01T12:00:00Z',
			}),
	})
	.meta({
		ref: userSchemaRef,
		description: 'Schema representing a user in the system.',
	});

export type UserSchemaType = z.infer<typeof userSchema>;
